import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getReleaseNotes,
  getReleaseNotesUnreadCount,
  postReleaseNoteRead,
  postReleaseNotesReadAll,
} from 'services/api';
import { ReleaseNote } from './constants';

const itemOrThrow = (response: any) => {
  if (!response?.data?.success) throw new Error(response?.data?.message ?? 'release-notes request failed');
  return response.data.item;
};

/** Contador del indicador del menú (Inicio) y de la pestaña Novedades. */
export const getReleaseNotesUnreadCountAsync: any = createAsyncThunk('releaseNotes/getUnreadCount', async () => {
  return (itemOrThrow(await getReleaseNotesUnreadCount()) ?? 0) as number;
});

export const getReleaseNotesAsync: any = createAsyncThunk('releaseNotes/getList', async () => {
  return (itemOrThrow(await getReleaseNotes()) ?? []) as ReleaseNote[];
});

export const markReleaseNoteReadAsync: any = createAsyncThunk('releaseNotes/markRead', async (id: string) => {
  itemOrThrow(await postReleaseNoteRead(id));
  return id;
});

export const markAllReleaseNotesReadAsync: any = createAsyncThunk('releaseNotes/markAllRead', async () => {
  itemOrThrow(await postReleaseNotesReadAll());
  return true;
});
